import { memo } from 'react';
import { usePortfolios } from '@/hooks/portfolio/usePortfolio';
import { BonesLayout } from './components/Layouts';
import loadable from '@loadable/component';

const DemoLayout = loadable(() => import('./components/Layouts'), {
  resolveComponent: (c) => c.DemoLayout,
});

const PortfolioCard = loadable(() => import('./components/PortfolioCard'), {
  resolveComponent: (c) => c.PortfolioCard,
});

const MemoizedPortfolioCard = memo(PortfolioCard);

export const PortfolioPositionCard = () => {
  const { isFetched: portfoliosIsFetched, data: portfolios = [] } =
    usePortfolios();

  if (!portfoliosIsFetched) return <BonesLayout />;

  if (portfolios.length === 0) return <DemoLayout />;

  return <MemoizedPortfolioCard portfolios={portfolios} />;
};
